import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey } from '../../../styles/const/colors'
import { textEllipsis } from '../../../styles/mixins/text'

const listRowPadding = 15
export const listColPadding = 10
export const listBorderColor = lightGrey
const useStyles = createUseStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: `5px 10px 5px ${listRowPadding}px`,
    minHeight: ({ rowHasMinHeight, isBigRow }) => rowHasMinHeight && (isBigRow ? 74 : 52),

    '&:not(:last-child)': {
      borderBottom: {
        width: 1,
        style: 'solid',
        color: listBorderColor
      }
    }
  },
  headlineRow: {
    display: 'flex',
    alignItems: 'center',
    color: darkGrey,
    fontSize: 12,
    padding: `11px 10px 11px ${listRowPadding}px`,
    minHeight: ['unset', '!important']
  },
  col: {
    padding: `0px ${listColPadding}px`,
    width: '100%',
    ...textEllipsis(),

    '&> span': {
      // skeleton fix to stretch it for column width
      width: '100%'
    }
  },
  headlineCol: {}
})

export default useStyles
